import { memo } from 'react';
import { InfoPopup } from 'shared/info_popup/InfoPopup';

export type AutoMaintenancePopupProps = Readonly<{
    softwareName?: string;
}>;

export const AutoMaintenancePopup = memo(
    ({ softwareName }: AutoMaintenancePopupProps) => (
        <InfoPopup title="Automatic Maintenance Task Creation">
            {softwareName
                ? `This will create an automatic task in the issue and a service request in ${softwareName}.`
                : 'This will create a maintenance task in the issue, which you can manage from the Tasks tab.'}
        </InfoPopup>
    ),
);
